import Select, { SelectOption } from '@anm/components/select/Select';
import { useSelectOptions } from '@anm/components/video-landings/selection/LogoSelection/BrandListModal/hooks';
import React, { useCallback, FC } from 'react';
import { useSelector } from 'react-redux';

import { brandSelectors } from '../../../store/modules/brands';
import useAddToBrand from './hooks/useAddToBrand';

import useBrandTypes from './hooks/useBrandTypes';

import {
  ButtonsWrapper,
  CancelButton,
  FieldWrapper,
  InputsWrapper,
  ModalTitle,
  ModalWrapper,
  SaveButton,
  SelectLabel
} from './Wrapper';

type SaveToBrandModalProps = {
  onClose: () => void;
  onBrandChange: (brandId: number) => void;
  projectId: string;
  fileName?: string;
};

const SaveToBrandModal: FC<SaveToBrandModalProps> = ({ onClose, onBrandChange, ...otherProps }) => {
  const brandList = useSelector(brandSelectors.selectBrands);
  const currentBrandId = useSelector(brandSelectors.selectCurrentBrandId);

  const [options, currentValue, _, handleSelectChange] = useSelectOptions({ brandList, currentBrandId });
  const [selectedCategory, currentBrandTypeOption, brandTypeOptions, handleSelectType] = useBrandTypes();
  const [isPending, addToBrand] = useAddToBrand({ fileType: selectedCategory, onSucess: onClose, ...otherProps });

  const handleBrandChange = useCallback((value: SelectOption<number>) => {
    const brandId = value.value as number;

    handleSelectChange(value);
    onBrandChange(brandId);
  }, []);

  return (
    <ModalWrapper onModalClose={onClose}>
      <ModalTitle title="Save to brand" description={`Save video to your brand to use it in Live Streaming Studio`} />
      <InputsWrapper>
        <FieldWrapper>
          <SelectLabel>Brand</SelectLabel>
          <Select name="brands" options={options} value={currentValue} onChange={handleBrandChange} />
        </FieldWrapper>
        <FieldWrapper>
          <SelectLabel>Type</SelectLabel>
          <Select name="type" options={brandTypeOptions} value={currentBrandTypeOption} onChange={handleSelectType} />
        </FieldWrapper>
      </InputsWrapper>
      <ButtonsWrapper>
        <CancelButton onClick={onClose} size="medium" variant="gray">
          Cancel
        </CancelButton>
        <SaveButton variant="light-blue" size="medium" onClick={addToBrand} isPending={isPending}>
          Save to brand
        </SaveButton>
      </ButtonsWrapper>
    </ModalWrapper>
  );
};

export default SaveToBrandModal;
